module.exports = __webpack_public_path__ + "img/logo.322ee3b7.png";